import React from "react";

function SubBanner({
  bgImg,         // 배경 이미지
  bgPosition, // 배경 이미지 위치
  logoImg,       // 로고 이미지
  title,         // 타이틀(혹은 JSX)
  description,   // 설명(혹은 JSX)
  buttons = [],  // 버튼 배열 [{label, onClick, url}]
  tabs = [],     // 탭 목록 [{label, active, onClick, url}]
  location = [], // 페이지 위치 표시용 [{label, url, active}]
}){

  return(
    <div className="sub_banner">
      <div className="sub_banner_inner">
        <div 
          className="banner_img"
          style={{
            backgroundImage:`url(${bgImg})`,
            backgroundPosition: bgPosition || 'center center'
          }}
        >{/* 배경 이미지 */}</div>

        <div className="banner_con">
          <div className="page_location">
            <i className="ic_home"></i>
            {location.map((loc,idx) => (
              <React.Fragment key={idx}>
                <i className="arrow_w"></i>
                <span className={loc.active ? 'active' :''}>{loc.label}</span>
              </React.Fragment>
            ))}
          </div>
          <div className="b_txt_box">
            <div className="banner_title">
            
              {logoImg && <figure><img src={logoImg} alt="logo"/></figure>}   {/* 배너 타이틀이 이미지일 때 */}
              {title && <h2>{title}</h2>}   {/* 배너 타이틀이 텍스트일 때 */}
              <p>{description}</p>
            </div>
            {buttons.length > 0 && (
              <div className="banner_btn">
                {buttons.map((btn, idx) => (
                  <a
                  key={idx}
                  href={btn.url}
                  target={btn.target || "_blank"}
                  rel="noopener noreferrer"
                >
                  {btn.label}
                </a>
                ))}
              </div>
            )}
          </div>
        </div>
        {tabs.length > 0 && (
          <div className="banner_tab">
            <div className="b_tab_inner">
              <ul>
                {tabs.map((tab, idx) => (
                  <li
                    key={idx}
                    className={tab.active ? "active" : ""}
                  >
                    <a 
                      href={tab.url} 
                      onClick={tab.onClick}
                    >
                      {tab.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
        
      </div>
    </div>
  )
};

export default SubBanner;